var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteDatasetLoaded)?_c('TeaserPressReleaseOverview',{attrs:{"id":_vm.anchorName,"all-press-releases-link":_vm.allPressReleasesLink,"headline":_vm.headline,"no-press-releases-text":_vm.noPressReleasesText,"teasers":_vm.teasers}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }